import React from 'react'
import PropTypes from 'prop-types'
import Range from '../Atoms/Range'
import Label from '../Atoms/Label'
import {lighten, desaturate} from 'polished'
import {i18n} from '../../../Utils'
import styled from 'styled-components'

const PasswordAmountRange = ({value, onChange, labelColor}) => {
    return (
        <Wrapper>
            <Label
                htmlFor={'password-length-range-input'}
                color={labelColor}>
                {value > 1
                    ? i18n('form.range.label.number_of_passwords', {number: value})
                    : i18n('form.range.label.number_of_passwords_singular', {number: value})}
            </Label>
            <RangeWrapper>
                <Range
                    id={'password-amount-range-input'}
                    sliderColor={desaturate(0.5, lighten(0.4, labelColor))}
                    trackColor={labelColor}
                    min={1}
                    max={100}
                    step={5}
                    value={value}
                    onChange={onChange}/>
            </RangeWrapper>
        </Wrapper>
    )
}

PasswordAmountRange.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    labelColor: PropTypes.string,
}

export default PasswordAmountRange

const Wrapper = styled.div`
    padding: 10px 0 10px 0;
`

const RangeWrapper = styled.div`
    margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Molecules/PasswordAmountRange.jsx